import {Component, Input} from '@angular/core';

@Component({
    templateUrl: './calendar-teaching-users.component.html',
    styleUrls: ['./calendar-teaching-users.component.scss'],
    standalone: false
})
export class CalendarTeachingUsersComponent {

  @Input('list') public list: {[p: string]: any};
  @Input('type') public type: string;

  get listArr() {
    return Object.values(this.list);
  }

}
